/**
 * Workspace chrome (menu z-80, dock z-70, help z-9998, tour z-9999) must sit
 * below modals/drawers or clicks appear to do nothing while dialogs open underneath.
 */
export const OVERLAY_Z_MODAL = 'z-[10050]';
/** Dialog/sheet content sits above its own backdrop. */
export const OVERLAY_Z_MODAL_CONTENT = 'z-[10051]';
export const OVERLAY_Z_POPOVER = 'z-[10060]';